import React from 'react'
import { useTranslation } from 'lib/i18n'

import styles from './ProfileNotAvailable.module.css'

function ProfileNotAvailable({ profileName, align = 'center' }) {
  const { t } = useTranslation()

  if (!profileName) {
    return null
  }

  return (
    <div
      className={styles.notAvailable}
      style={{ textAlign: align }}
      data-cy="profileNotAvailable"
    >
      {t(
        'SingleProductButton.notAvailable',
        'You cannot book {{profileName}} right now. Come back later!',
        {
          profileName,
        },
      )}
    </div>
  )
}

export default ProfileNotAvailable
